<ng-container [ngSwitch]="format">
    <span *ngSwitchCase="'percent'">{{ data }}%</span>
    <gtd-ui-field-default-money [data]="data" *ngSwitchCase="'money'"></gtd-ui-field-default-money>
    <span *ngSwitchDefault>{{ data }}</span>
</ng-container>